<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import ToggleSwitch from 'primevue/toggleswitch'
import { computed, ref } from 'vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const toggleRef = ref<InstanceType<typeof ToggleSwitch> | undefined>()
const trueValue = computed(() => props.context.attrs.trueValue)
const falseValue = computed(() => props.context.attrs.falseValue)

async function onUpdated(value?: boolean | undefined) {
  await props.context.node.input(value)
  ;(toggleRef.value as any)?.$el.dispatchEvent(new Event('change', { bubbles: true }))
}
</script>

<template>
  <div class="flex items-center gap-2 whitespace-nowrap">
    <label class="font-semibold" :class="context.attrs.labelClass">
      {{ context.attrs.labelOverride }}
    </label>
    <ToggleSwitch
      :true-value="trueValue"
      :false-value="falseValue"
      @change.stop
      ref="toggleRef"
      v-bind="context.attrs"
      :model-value="context.value"
      @update:model-value="onUpdated"
    />
  </div>
</template>
